import { trackEvent } from '../../../utils/tracking/mixpanel'
import { trackOptimizelyEvent } from '../../../utils/tracking/optimizely'
import { EventName } from '../../../utils/types'

type EventProperties = Record<string, string | number | boolean | null | undefined>

/**
 * Fire a match-screen event to both Mixpanel and Optimizely with the same name
 * and properties.
 */
export const trackMatchScreenEvent = (eventName: EventName, properties: EventProperties = {}): void => {
  trackEvent('MatchScreen', eventName, properties)
  trackOptimizelyEvent(eventName, properties)
}
